// 新spm上报
import './web-reporter';
// 图片设置指令
import './img';
// 路由跳转插件和指令
import './jump';

